import { useRouter } from 'next/router';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';

import { signUpManager } from '../../models';
import { SignUpStep } from '../../models/enums';

interface Props {
  disabled?: boolean;
}

export const StepCompleteContract: React.FC<Props> = ({ disabled }) => {
  const router = useRouter();
  const { currentStep } = useSnapshot(signUpManager);

  if (currentStep !== SignUpStep.COMPLETE_CONTRACT) {
    return null;
  }

  const handleClick = () => {
    const urlSearchParams = new URLSearchParams(globalThis.location.search);
    const dialog = urlSearchParams.get('dialog') || 'complete-contract';
    urlSearchParams.delete('step');
    urlSearchParams.set('dialog', dialog);
    urlSearchParams.sort();
    router.push({
      pathname: '/',
      search: urlSearchParams.toString(),
    });
  };

  return (
    <div className="space-y-9">
      <Button size="xl" variant="solid" disabled={disabled} onClick={handleClick}>
        Join contract
      </Button>
    </div>
  );
};
